import ArticleLayout from '@/components/base/ArticleLayout';
import { allArticles } from '@/mocks/seoArticles';

export default function PagamentiSicuriPage() {
  return <ArticleLayout data={allArticles['pagamenti-sicuri']} />;
}